<template>
  <div>
    <div class="info-title">
      <span>报警信息</span>
    </div>
    <div class="info-wrap">
      <div class="tableBox" v-for="(item,index) in resInfo" :key="index">
          <div
            class="tableItem"
            :class="item.status === '严重'?'yanzhong':item.status==='yujing'?'warning':'zhengchang'">
            <div class="tableName">{{ item.name }}</div>
            <div class="line"></div>
            <div class="siteBox">
              <div class="siteOne">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime }}
                  <span class="second">秒</span>
                </div>
                <div class="pv">
                  <span>PV：{{ item.pv?item.pv:'---' }}</span>
                  <span>UV：{{ item.uv?item.uv:'---' }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage }}</span>
                </div>
              </div>
              <div class="siteTwo">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address2 }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime2 }}
                  <span class="second">秒</span>
                </div>
                <div class="pv">
                  <span>PV：{{ item.pv2?item.pv2:'---' }}</span>
                  <span>UV：{{ item.uv2?item.uv2:'---' }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage2 }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage2 }}</span>
                </div>
              </div>
            </div>
            <div class="tableBtn">
              <div class="siteBtnTwo" @click="siteTwoShow(index,$event)" v-if="item.address2">站点二</div>
              <div class="siteBtnOne" @click="siteOneShow(index,$event)" v-if="item.address">站点一</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

// 
export default {
  data() {
    return {
      name:'',
      resInfo: [{
        address: "",
        address2: "",
        baiduid: '',
        cpuUsage: '',
        cpuUsage2: '',
        id: '',
        memUsage: '',
        memUsage2: '',
        name: "",
        pv: '',
        pv2: '',
        resCode: "",
        resCode2: "",
        resTime: "",
        resTime2: "",
        server: '',
        server2: '',
        staff: "",
        status: "",
        status2: "",
        uv: '',
        uv2: ''
      }]
    };
  },
  mounted() {
    this.getRequest(location.href,"name")
  },
  methods: {
    getRequest:function (url,name){
      var me = this;
      var pattern = new RegExp("[?&]"+name+"\=([^&]+)", "g");
      var matcher = pattern.exec(url);
      var items = null;
      if(null != matcher){
          try{
              items = decodeURIComponent(decodeURIComponent(matcher[1]));
          }catch(e){
              try{
                  items = decodeURIComponent(matcher[1]);
              }catch(e){
                  items = matcher[1];
              }
          }
      }
      me.getSiteData(items)
    },
    getSiteData:function(name){
      var me = this;
      axios.post(process.env.baseURL + 'getErrSite',{
        name: name
      })
      .then(function(res){
        if (res.data.ok == 1) {
          me.resInfo = [res.data.data]
        }
      })
    },
    siteOneShow(index, evt) {
      var me = this;
      if (evt.currentTarget.previousElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "0";
        siteOne.style.opacity = "1";
        siteTwo.style.top = "100%";
        siteTwo.style.opacity = "0";
        evt.toElement.style.backgroundColor = "#222a36";
        evt.currentTarget.previousElementSibling.style.backgroundColor =
          "transparent";
      }
    },
    siteTwoShow(index, evt) {
      var me = this;
      if (evt.currentTarget.nextElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "-80%";
        siteOne.style.opacity = "0";
        siteTwo.style.top = "0";
        siteTwo.style.opacity = "1";
        evt.currentTarget.nextElementSibling.style.backgroundColor =
          "transparent";
        evt.toElement.style.backgroundColor = "#222a36";
      }

    },
  }
};
</script>
<style lang="less" scoped>
  .info-title {
    text-align: center;
    span {
      display: inline-block;
      text-align: center;
      color: #fff;
      width: 80vw;
      font-size: 18px;
    }
    padding: 5px 0;
    margin-bottom: 4vh;
    line-height: 5vh;
  }
  .info-wrap {
    display: flex;
    width: 90%;
    margin: 0 auto;
    top: 0;
    left: 0;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    padding-bottom: 25px;
  }
  .tableBox {
    width: 100%;
    height: 190px;
    display: inline-block;
    margin: 0 1vw 1vh 0;
  }
  .tableItem {
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: rgba(117, 176, 243, 0.2);
    background-color: #313a46;
    border-radius: 7px;
    padding: 10px 2vw;
    line-height: 14px;
    text-align: left;
    font-size: 14px;
    position: relative;
    overflow: hidden;
    .tableName {
      text-align: left;
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .line {
      width: 80%;
      height: 2px;
      background: rgb(24, 30, 38, 0.4);
      position: absolute;
      top: 32px;
      left: 0;
    }
    .siteBox {
      width: 100%;
      height: 80%;
      overflow: hidden;
      position: relative;
      top: 5%;
      .siteOne {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        transition: all 0.5s;
      }
      .siteTwo {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 100%;
        transition: all 0.5s;
      }
      .address {
        margin-top: 12px;
        font-size: 13px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .speed {
        margin-top: 6px;
        font-size: 13px;
        .second {
          font-size: 13px;
        }
      }
      .pv {
        margin-top: 6px;
        font-size: 13px;
        span {
          padding-right: 15%;
        }
      }
      .cpu {
        margin-top: 9px;
        font-size: 13px;
        .lineLeft {
          display: inline-block;
          float: left;
        }
        .lineBox {
          width: 35%;
          height: 12px;
          border: 1px solid rgb(146, 146, 148);
          display: inline-block;
          background: #181e26;
          line-height: 10px;
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
          position: relative;
        }
        .lineItem {
          position: absolute;
          width: 1%;
          height: 100%;
          top: 0%;
          z-index: 99;
          overflow: hidden;
        }
        .boxItem {
          width: 100%;
          height: 100%;
          background: linear-gradient(to right, #21a2f5, #fafb0d, #f56c6c);
        }
        .wLine {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0%;
          z-index: 99;
          span {
            width: 1px;
            height: 100%;
            background: rgb(148, 146, 146);
            margin-left: 15.2%;
            display: inline-block;
          }
        }
        .lineText {
          padding-left: 5px;
        }
      }
    }
    .tableBtn {
      position: absolute;
      bottom: 5%;
      right: 5%;
      width: 100%;
      font-size: 12px;
      z-index: 99;
      div {
        border: 1px solid rgb(148, 146, 146);
        padding: 2px 5px;
        border-radius: 10px;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
          0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        float: right;
        display: inline-block;
        margin-left: 8%;
        cursor: pointer;
      }
      .siteBtnOne {
        background: #222a36;
      }
    }
    .tableLike {
      position: absolute;
      top: 4px;
      right: 5%;
      img {
        width: 25px;
        cursor: pointer;
      }
    }
  }
      .zhengchang {
        background: linear-gradient(
          to top right,
          #313a46 20%,
          #444e58 80%
        ); //正常
      }
      .yujing {
        background: linear-gradient(
          to top right,
          rgb(160, 116, 49) 20%,
          rgba(146, 116, 71, 0.6) 80%
        ); //严重
      }
      .yanzhong {
        background: linear-gradient(
          to top right,
          #965252 20%,
          #5c3938 80%
        ); //严重
      }
</style>


// WEBPACK FOOTER //
// src/pages/errmessage.vue